import React, { forwardRef, useState } from "react";

import {
  FormWrapper,
  FormInput,
  FormLabel,
  FormInputRow,
  FormMessage,
  Button,
  FormTitle,
} from "../StyledComp/StyledComp";
import { useDispatch } from "react-redux";
import {
  updateMember_Sections,
  updateMember_Tags,
} from "../../store/memberApiSlice";
interface IMemberTags {
  Fee: number;
  Id: number;
  Description: string;
  MemberTag: string;
  isSelected: boolean;
}

interface IProps {
  key: number;
  memberTag: IMemberTags;
  isSection: boolean;
}

const MDTagsMultipleOptionItems: React.FC<IProps> = (props) => {
  const dispatch = useDispatch();
  const memberTag = props.memberTag;
  // const [isSelected, setISSelected] = useState(props.section.isSelected);
  const handleChecked = (
    event: React.ChangeEvent<HTMLInputElement>,
    SectionName: string
  ) => {
    // setISSelected(!isSelected);
    memberTag.isSelected = !memberTag.isSelected;
  };
  // console.log("memberTag:", memberTag);

  return (
    <>
      <div key={memberTag.Id} className="checkboxgroup">
        <input
          id={memberTag.MemberTag}
          className="checkbox"
          type="checkbox"
          checked={memberTag.isSelected}
          onChange={(event) => handleChecked(event, memberTag.MemberTag)}
        />
        <div>{memberTag.MemberTag}</div>
      </div>
    </>
  );
};

export default MDTagsMultipleOptionItems;
